<template>
  <DropdownItem
    v-if="authUser.isSuperAdmin"
    icon="pencil-write-alternate"
    icon-classes="has-text-weight-light"
    :label="$t('core.text-editor-tool')"
    :click-fn="openRichTextEditor"
  />
</template>

<script>
import { HasAuthUserMixin } from '/@/modules/core/app/mixins/HasAuthUserMixin';
import DropdownItem from '@/modules/core/app/components/DropdownItem.vue';
import { HasCurrentEstateMixin } from '@/modules/core/app/mixins/HasCurrentEstateMixin';
import { NavCypressAttribute } from '@/modules/core/nav/constants/NavCypressAttribute';
import ModalService from '@/modules/core/ui/services/ModalService';
import RichTextEditorToolModal from '@/modules/messenger/_modules/message/components/presentational/RichTextEditorToolModal.vue';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'RichTextEditorToolDropdownItem',
  mixins: [HasAuthUserMixin, HasCurrentEstateMixin],
  components: { DropdownItem },
  static: {
    NavCypressAttribute
  },
  methods: {
    openRichTextEditor() {
      ModalService.show({
        parent: this,
        component: RichTextEditorToolModal,
        width: '1000px'
      });
    }
  }
};
</script>
